import { injectable } from 'inversify';

import { IExampleRepository } from '@/domain/repositories/example.repository.interface';
import { Example, Result } from '@/entities';
import { exampleDtoToExample } from '@/infrastructure/mapper';
import { getExample } from '@/infrastructure/network/data';

@injectable()
export class ExampleRepository implements IExampleRepository {
	async getExample(uuid: string): Promise<Result<Example>> {
		const result = await getExample({ uuid });
		if (result.statusCode === 200) {
			// if fetch call was successfull, api response (dto object) is mapped to model used by rest of application
			return { data: exampleDtoToExample(result.data), statusCode: result.statusCode };
		} else {
			return { statusCode: result.statusCode, correlationId: result.correlationId, error: result.error };
		}
	}
}
